'use es6';

import { fromJS } from 'immutable';
import { serializableError } from '../utils/utils';
import ActionTypes from './ActionTypes';
import { getMonetizationProducts } from '../features/monetization';
export const requestProducts = () => {
  return dispatch => {
    dispatch({
      type: ActionTypes.PRODUCTS_REQUESTING
    });
    const promise = getMonetizationProducts().then(res => dispatch({
      type: ActionTypes.PRODUCTS_RECEIVED,
      payload: fromJS(res)
    }), err => dispatch({
      type: ActionTypes.PRODUCTS_ERROR,
      payload: serializableError(err)
    }));
    promise.catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
    return promise;
  };
};